<template>
  <w-icon-wrapper
    :height='24'
    :width='22'
    icon-name='work-delete-icon'
    view-box='0 0 22 24'
  >
    <g
      id='_45_Löschen_Icon'
      data-name='45 Löschen_Icon'
      transform='translate(-1)'
    >
      <path
        id='Pfad_55734'
        d='M22,4H16A4,4,0,0,0,8,4H2A1,1,0,0,0,2,6H3.105l2,18H18.9l2-18H22a1,1,0,0,0,0-2ZM12,2a2,2,0,0,1,2,2H10A2,2,0,0,1,12,2Zm5.1,20H6.9L5.117,6H18.883Z'
        data-name='Pfad 55734'
        fill='currentColor'
      />
      <path
        id='Pfad_55735'
        d='M10,10a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V11A1,1,0,0,0,10,10Z'
        data-name='Pfad 55735'
        fill='currentColor'
      />
      <path
        id='Pfad_55736'
        d='M14,10a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V11A1,1,0,0,0,14,10Z'
        data-name='Pfad 55736'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconDelete' };
</script>
